let dataLayerInited = false;
export class DataLayerTracker
{
    constructor(data) {
        this.dataLayer = this.init(data);
    }

    /**
     * Инициализируем начальный dataLayer
     * @param data
     * @returns {*|Array}
     */
    init(data) {
        window.dataLayer = window.dataLayer || [];
        if (dataLayerInited) {
            return window.dataLayer;
        }

        const initialLayer = {
            isLogged: data.user.authorized,
        };

        if (initialLayer.isLogged) {
            initialLayer.user = {
                birthdate: data.user.born_at ? data.user.born_at.short : 'unknown',
                gender: data.user.gender ? data.user.gender : 'unknownn',
                regDate: data.user.registered_at.short
            };
        }

        switch (data.route) {
            case 'index':
                initialLayer.pagetype = 'main';
                break;
            case 'products':
                initialLayer.pagetype = 'catalog';
                break;
            case 'product':
                initialLayer.pagetype = 'product';
                break;
            case 'cart':
                initialLayer.pagetype = 'basket';
                break;
            case 'order':
                initialLayer.pagetype = 'order';
                break;
            case 'order.thankyoupage':
                initialLayer.pagetype = 'confirmation';
                break;
            case '404':
                initialLayer.pagetype = '404';
                break;
            default:
                initialLayer.pagetype = 'other';
                break;
        }


        window.dataLayer.push(initialLayer);

        dataLayerInited = true;
        return window.dataLayer;
    }

    push(layer) {
        this.dataLayer.push(layer);
    }

    categoryPageView(products) {

        // #18588 Событие используется для Criteo счетчика. Туда нужно передавать только три первых товара из списка
        const productIds = products.map((product) => {
            return product.id;
        });

        this.push({
            'event': 'viewList',
            'item': productIds.slice(0, 3)
        });
    }

    productPageView(product) {

        this.push({
            event: 'ecommerceDetail',
            ecommerce: {
                detail: {
                    'actionField' : {
                        'list' : localStorage.getItem('analitics_product_list')
                    },
                    products: {
                        name: product.name,
                        id: product.id,
                        price: parseFloat(product.price),
                        brand: product.vendor,
                        category: product.category,
                    }
                }
            }
        });

        this.push({
            event: 'productDetails',
            ecommerce: {
                detail: {
                    products: {
                        name: product.name,
                        id: product.id,
                        price: parseFloat(product.price),
                        brand: product.vendor,
                        category: product.category,
                        variant: ''
                    }
                }
            }
        });
    }

    basketItemAdd(product) {
        this.push({
            'event': 'addToCart',
            'ecommerce': {
                'add': {
                    'products': collectBasketItems([product])
                }
            }
        });
    }

    basketPageView(basket) {
        this.push({
            'ecommerce': {
                'checkout': {
                    'actionField': {'step': 1},
                    'products': collectBasketItems(basket)
                }
            }
        });

        this.push({
            'event' : 'ecommerceCheckout',
            'ecommerce': {
                'checkout': {
                    'actionField': {'step': 1},
                    'products': collectBasketItems(basket)
                }
            }
        });
    }

    orderPageView(basket) {
        this.push({
            'ecommerce': {
                'checkout': {
                    'actionField': {'step': 2},
                    'products': collectBasketItems(basket)
                }
            }
        });

        this.push({
            'event' : 'ecommerceCheckout',
            'ecommerce': {
                'checkout': {
                    'actionField': {'step': 2},
                    'products': collectBasketItems(basket)
                }
            }
        });
    }

    orderPageReload(basket) {
        this.push({'ecommerce': {
            'checkout': {
                'actionField': {'step': 3},
                'products': collectBasketItems(basket)
            }
        }});

        this.push({
            'event' : 'ecommerceCheckout',
            'ecommerce': {
                'checkout': {
                    'actionField': {'step': 3},
                    'products': collectBasketItems(basket)
                }
            }
        });
    }

    orderPageLoyalityCardValidtion(card) {
        this.push({
            'event': 'checkoutOption',
            'ecommerce': {
                'checkout_option': {
                    'actionField': {'step': 2, 'option': 'подтвердил пин код бонусной карты'},
                    'card1' : card.number,
                    'card2' : card.pin
                }
            }
        })
    }

    orderThankyouPageView(order, basket) {
        this.push({
            'event': 'Transaction',
            'ecommerce': {
                'purchase': {
                    'actionField': {
                            id: order.id,
                            affiliation: window.location.host,
                            revenue: order.price,
                            tax: order.tax,
                            shipping: order.delivery_price,
                            coupon: order.coupon
                        },
                    'products': collectBasketItems(basket)
                }
            }
        });

        this.push({ecommerceGA4: null});
        this.push({
            event: 'purchaseGA4',
            ecommerceGA4: {
                transaction_id: order.id,
                value: order.price,
                coupon: order.coupon,
                items: collectBasketItemsGa4(basket)
            }
        });
    }
}


let collectBasketItems = (basket) => {
    const items = [];
    basket.forEach((basketItem) => {
        items.push(formatBasketItem(basketItem));
    });
    return items;
};
let formatBasketItem = (product) => {
    if (!product) {
        return {};
    }

    return {
        name: product.name,
        id: product.id,
        price: product.price,
        brand: product.vendor,
        category: product.category,
        variant: '',
        quantity: product.quantity
    };
}


let formatBasketItemGa4 = (product) => {

    if (!product) {
        return {};
    }

    return {
        item_name: product.name,
        item_id: product.id,
        price: product.price,
        item_brand: product.vendor,
        item_category: product.category,
        quantity: product.quantity
    };
};
let collectBasketItemsGa4 = (basket) => {
    const items = [];
    basket.forEach((basketItem) => {
        items.push(formatBasketItemGa4(basketItem));
    });
    return items;
};


// WEBPACK FOOTER //
// ./modules/tracker/datalayer.js